module.exports = __webpack_public_path__ + "img/frame (122).eff7d181.jpg";